<template>
  <div>
    <div class="loading" v-if="display.loading">
      <div class="load">
        <hr><hr><hr><hr>
        <div class="loadback"></div>
      </div>
    </div>
    <div v-if="display.loaded">
      <section class="header-img" v-if="!partner.banner_image">
        <div class="container">
          <img src="/static/front/images/wcu-default-banner-new.png" alt="wcu-default-banner-new.png">
        </div>
      </section>
      <section class="header-img" v-if="partner.banner_image">
        <div class="container">
          <img :src="partner.banner_image" id="banner_image" @error="onImageLoadFailure($event, 'banner_image')" :alt="partner.org_name">
        </div>
      </section>
      <section class="wc-top-sec-text">
        <div class="container">
          <div class="row">
            <div class="col-md-3">
              <aside><img :src="partner.org_image" id="wc_profile_image" @error="onImageLoadFailure($event, 'wc_profile_image')" :alt="partner.org_image" rel="preload"></aside>
            </div>
            <div class="col-md-6">
              <section>
                <h2>{{partner.org_name}}</h2>
                <p v-if="partner.User">Worthy Cause Since: {{ partner.User.created_at | moment("D MMM 'YY")}}</p>
                <p>Website: <a :href="partner.website" target="_blank">{{partner.website}}</a></p>
                <p>
                  <span v-if="user"> <a @click="$modal.show('wcuContactInfoModal')"> See Contact Info </a> </span>
                  <span v-if="user && partner.story_url"> | </span>
                  <a v-if="partner.story_url" :href="partner.story_url" target="_blank">Read their Story</a></p>
                <div class="social-sec">
                  <a v-if="partner.facebook_profile_id" :href="partner.facebook_profile_id" target="_blank"><img src="/static/front/images/fb-icon.png" alt="fb-icon.png"></a>
                  <a v-if="partner.linkedin_profile_id" :href="partner.linkedin_profile_id" target="_blank"><img src="/static/front/images/link-din.png" alt="link-din.png"></a>
                  <a v-if="partner.twitter_profile_id" :href="partner.twitter_profile_id" target="_blank"><img src="/static/front/images/x-icon.png" alt="tw-icon.png"></a>
                  <a v-if="partner.youtube_profile_id" :href="partner.youtube_profile_id" target="_blank"><img src="/static/front/images/you-tub-icon.png" alt="you-tub-icon.png"></a>
                  <a v-if="partner.instagram_profile_id" :href="partner.instagram_profile_id" target="_blank"><img src="/static/front/images/insta.png" alt="insta-icon.png"></a>
                </div>
              </section>
            </div>
            <div class="col-md-3">
              <a class="b-btn red-btn" @click="scrollDown('wcu-projects')">GIVE</a>
            </div>
          </div>
        </div>
      </section>

      <section class="wc-plan-sec">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <h2>
                <span v-if="topCategories[0]">{{topCategories[0]}}</span><span v-if="topCategories[1]">, {{topCategories[1]}}</span>
              </h2>
              <p>FOCUS</p>
            </div>
            <div class="col-md-4">
              <h2>{{spacify(companyTotalImpact)}}</h2>
              <p>IMPACTS RAISED</p>
            </div>
            <div class="col-md-4" v-if="partner.User">
              <h2>{{partner.User.wcu_projects.length}}</h2>
              <p>PROJECTS</p>
            </div>
          </div>
        </div>
      </section>

      <section class="wc-about-sec">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <aside>
                <h3>REGISTERED IN</h3>
                <ul>
                  <li v-for="reg in this.partner.RegCountry" v-bind:key="reg.id">
                    <img :src="'/static/front/images/flags/' + reg.image" :title="reg.name" :alt="reg.name">&nbsp; {{reg.name}}
                  </li>
                </ul>
              </aside>
              <aside>
                <h3>ADDRESS</h3>
                <ul>
                  <p>{{partner.office_address_1}}
                    {{partner.office_city_name}}<br>
                    {{partner.office_zip_code}}
                    {{ partner.office_country_id ? ',' : ''}}
                    {{getCountryName(partner.office_country_id)}}</p>
                </ul>
              </aside>
              <aside class="m-0">
                <h3>OPERATING IN</h3>
                <ul>
                  <li v-for="ope_countries in this.partner.OpeCountry" v-bind:key="ope_countries.id">
                    <img :src="'/static/front/images/flags/' + ope_countries.image" :title="ope_countries.name" :alt="ope_countries.image">&nbsp; {{ope_countries.name}}
                  </li>
                </ul>
              </aside>
            </div>
            <div class="col-md-8">
              <h2>About Us</h2>
              <p v-if="partner.org_aboutus">{{partner.org_aboutus}}</p><br>
              <h2>Our Mission</h2>
              <p v-if="partner.org_mission">{{partner.org_mission}}</p><br>
            </div>
          </div>
        </div>
      </section>

      <section class="wc-video-sec" v-if='partner.org_story && partner.org_story.story_media != null'>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-12"><h2>Organization Photos and Videos</h2></div>
            <div class="col-md-4" v-for="(story_media, index) in partner.org_story.story_media" v-bind:key="index">
              <iframe class="media-video" :src="story_media.url" allowfullscreen frameborder="0" v-if="story_media.type === 'video_url'"></iframe>
              <img class="media-image" :src="story_media.url" v-if="story_media.type === 'photo'" :alt="story_media.url">
            </div>
          </div>
        </div>
      </section>

      <section class="mobile-wc-video-sec" v-if='partner.org_story && partner.org_story.story_media != null' >
      <div class="row justify-content-center">
        <div class="col-md-12"><h2>Organization Photos and Videos</h2></div></div>
        <div id="carouselExampleControls1" class="carousel slide project-img-slide" data-ride="carousel" v-if='partner.org_story.story_media.length > 1'>
          <div class="carousel-inner">
            <div class="carousel-item" v-for="(story_media, index) in partner.org_story.story_media" v-bind:key="index" :class="(index === 0) ? 'active' : ''">
              <iframe class="media-video" :src="story_media.url" allowfullscreen frameborder="0" v-if="story_media.type === 'video_url'"></iframe>
              <img class="media-image" :id="'media' + index" :src="story_media.url" v-if="story_media.type === 'photo'" @error="onImageLoadFailure($event, 'media' + index)" :alt="story_media.url">
            </div>
          </div>
          <a class="carousel-control-prev" href="#carouselExampleControls1" role="button" data-slide="prev">
            <i class="fas fa-chevron-left"></i>
          </a>
          <a class="carousel-control-next" href="#carouselExampleControls1" role="button" data-slide="next">
            <i class="fas fa-chevron-right"></i>
          </a>
        </div>
      </section>
      <span id="scroll-here" class="scroll-here"></span>
      <section class="wcu-projects wc-project-sec" id="wcu-projects" v-if="partner.User && partner.User.wcu_projects.length > 0">
        <div class="container" v-if="user">
          <div class="row">
            <div class="col-md-12">
              <h2>Projects Managed By <span>{{ partner.org_name }}</span></h2>
            </div>
          </div>
          <div class="row justify-content-center" style="margin-top:15px; margin-bottom:25px;">
            <div class="col-lg-3 col-md-6" v-for="project in limitBy(partner.User.wcu_projects, countPerPage, start)" v-bind:key="project.id">
              <!--<div class="project-card" v-for="(project, index) in partner.user.wcu_projects" v-bind:key="index">-->
              <div class="project-card">
                <div class="cardSmallLinks">
                  <span v-if="user" @click="fav(project)" :id="project.id" :class="(project.is_favorite) || (isFav(project.id)==false) ? 'heart-icon red-heart' : 'heart-icon'"><i class="fas fa-heart"></i></span>
                  <router-link class="custViewDetailLink" :to="{ name: project.is_bundle == 0 ? 'projectdetail' : 'bundledetail', params: {id: project.id } }" target="_blank" id="project-details"><img :src="'/static/front/images/info-icon-black.svg'" alt="alt"></router-link>
                </div>
                <img :src="getProjectImage(project.image_square.image_name)" :id="'project_image_' + project.id" @error="onImageLoadFailure($event, 'project_image_' + project.id)" @click="redirectAnotherProject(project)" style="cursor: pointer" :alt="project.image_square.image_name">
                <div class="card-text">
                  <h2>{{project.project_title}}</h2>
                  <aside><img :src="'/static/front/images/category-list-new.svg'" alt="alt" style="width:17px"> <span>{{project.categories[0].name}}</span></aside>
                  <aside><img :src="'/static/front/images/location-pin.svg'" alt="alt" style="width:17px"> {{getCountryName(project.country_id)}}</aside>
                  <section>
                    <span>From </span><strong>US ${{getLowestImpact(project.impacts)}}</strong>
                  </section>

                  <div class="custRecurringOverlay" :id="'cart' + project.id">
                    <button class="close" @click="openCard('close', project.id)"><img :src="'/static/front/images/close-black-icon.svg'" alt="alt"></button>
                    <div class="custAddImpactLevelSec">
                      <div class="impactLevelTitle">
                        <div class="inner">
                          Impact Level <span
                      v-tooltip.top="{ content: 'Select the level of impacts you want to create with this project.', class: 'normal-tooltip' }"
                      class="infopop" data-container="body" data-toggle="popover" style="vertical-align: top;line-height: normal;font-size: 0;padding-top: 0px;display: inline-block;"><img src="/static/front/images/info-icon.svg" alt=""></span>
                        </div>
                      </div>
                      <select v-model="project.selectedImpact">
                        <option :value="null">Impact Level</option>
                        <option v-for="(impact) in project.impacts" v-bind:key="impact.id" :value="impact">US
                          ${{ impact.impact_level_cost|currency }} -
                          {{ impact.impact_level_title }}
                          ({{ impact.impact_unit }} - {{ impact.impact_unit == 1 ? 'Impact' : 'Impacts' }})
                        </option>
                      </select>
                      <div class="custAddtoCartBox" v-if="user">
                        <div class="qty-sec">
                          <input type="hidden" v-model="countInc"/>
                          <input type="button" value="-" @click="decrease(project)">
                          <input type="text" style="text-align: center;" :id="'qty' + project.id" :value="1">
                          <input type="button" value="+" @click="increase(project)">
                        </div>
                        <p :class="project.should_exclude != '1' ? 'btn-sec rml-10' : 'btn-sec'" style="display: inline-block;">
                          <button class="red-btn" @click="addToCart(project, project.selectedImpact)" :disabled="(user.role_id === 12)?true:false">
                            Add to cart
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="custRecurringOverlay" :id="'recurring' + project.id" style="display:none;">
                    <button class="close" @click="openCard('close', project.id)"><img :src="'/static/front/images/close-black-icon.svg'" alt="alt"></button>
                    <div class="custAddImpactLevelSec">
                      <div class="impactLevelTitle">
                        <div class="inner">
                          How would you like to proceed?
                        </div>
                      </div>
                      <div class="proceedOptions">
                        <a href="#" class="white-btn" @click="loadProjectModal(project, 'monthly')">Create Monthly Recurring Impacts</a>
                        <a href="#" class="white-btn" @click="loadProjectModal(project, 'manual')">Create Activity-based Impacts</a>
                      </div>
                    </div>
                  </div>
                  <div class="custProjectCardFooter" v-if="user">
                    <div class="tab" :id="'recurringBtn' + project.id" @click="openCard('recurring', project.id)" v-if="project.should_exclude != '1'">
                      <img :src="'/static/front/images/plus.svg'" alt="alt" style="width:17px">
                      Recurring Impacts
                    </div>
                    <div class="tab" :id="'addBtn' + project.id" @click="openCard('cart', project.id)">
                      <img :src="'/static/front/images/shopping_cart_icon_black.svg'" alt="alt" style="width:17px">
                      Add to Cart
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container" v-else>
          <div class="row">
            <div class="col-md-12 text-center" >
                <a href="https://b1g1.com" target="_blank" style="width:inherit;">
                  <img :src="'/static/front/images/22Website_-_Worthy_Cause_Banner.png'" alt="alt" style="width:inherit; margin-bottom: 30px;">
                </a>
            </div>
          </div>
        </div>
        <div class="pagination-sec for-dektop" v-if="countPages > 1 && user">
          <paginate
            :container-class="'pagination'"
            :click-handler="setPage"
            :next-text="'<i class=\'fas fa-chevron-right\'></i>'"
            :page-count="countPages"
            :prev-text="'<i class=\'fas fa-chevron-left\'></i>'"
            ref="teamPaginateBottom">
          </paginate>
        </div>
      </section>

      <section class="wcu-projects project-more-sec owl-for-mobile" v-if="partner.User && partner.User.wcu_projects.length > 0">
        <div class="container" v-if="user">
          <div class="row">
            <div class="col-md-12">
              <h2>Projects Managed By <span>{{ partner.org_name }}</span></h2>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item" v-for="(project, index) in partner.User.wcu_projects" v-bind:key="index" :class="(index === 0) ? 'active' : ''" >
                    <div class="project-card">
                      <div class="cardSmallLinks">
                        <span v-if="user" @click="fav(project)" :id="project.id" :class="(project.is_favorite) || (isFav(project.id)==false) ? 'heart-icon red-heart' : 'heart-icon'"><i class="fas fa-heart"></i></span>
                        <router-link class="custViewDetailLink" :to="{ name: project.is_bundle == 0 ? 'projectdetail' : 'bundledetail', params: {id: project.id } }" target="_blank"><img :src="'/static/front/images/info-icon-black.svg'" alt="alt"></router-link>
                      </div>
                      <img v-if="project && project.image_square" :src="getProjectImage(project.image_square.image_name)" :id="'project_image_' + project.id" @error="onImageLoadFailure($event, 'project_image_' + project.id)" @click="redirectAnotherProject(project)" style="cursor: pointer" :alt="project.image_square.image_name">
                      <div class="card-text">
                        <h2>{{project.project_title}}</h2>
                        <aside v-for="category in project.categories" :key="category.id">
                          <img :src="'/static/front/images/category-list-new.svg'" alt="alt" style="width:17px"> <span>{{category.name}}</span>
                        </aside>
                        <aside><img :src="'/static/front/images/location-pin.svg'" alt="alt" style="width:17px"> {{project.country.name}}</aside>
                        <section>
                          <span v-if="project.impacts.length > 1" ng-show="info.project_impact_cost.length > 1">From </span><strong>US {{project.min_cost|currency}}</strong>
                        </section>

                        <div class="custRecurringOverlay" :id="'cart' + project.id">
                          <button class="close" @click="openCard('close', project.id)"><img :src="'/static/front/images/close-black-icon.svg'" alt="alt"></button>
                          <div class="custAddImpactLevelSec">
                            <div class="impactLevelTitle">
                              <div class="inner">
                                Impact Level <span
                                v-tooltip.top="{ content: 'Select the level of impacts you want to create with this project.', class: 'normal-tooltip' }"
                                class="infopop" data-container="body" data-toggle="popover" style="vertical-align: top;line-height: normal;font-size: 0;padding-top: 0px;display: inline-block;"><img src="/static/front/images/info-icon.svg" alt=""></span>
                              </div>
                            </div>
                            <select v-model="project.selectedImpact">
                              <option :value="null">Impact Level</option>
                              <option v-for="(impact) in project.impacts" v-bind:key="impact.id" :value="impact">US
                                ${{ impact.impact_level_cost|currency }} -
                                {{ impact.impact_level_title }}
                                ({{ impact.impact_unit }} - {{ impact.impact_unit == 1 ? 'Impact' : 'Impacts' }})
                              </option>
                            </select>
                            <div class="custAddtoCartBox" v-if="user">
                              <div class="qty-sec">
                                <!-- <input type="hidden" v-model="countInc"/> -->
                                <input type="button" value="-" @click="decrease(project)">
                                <input type="text" style="text-align: center;" :id="'qty' + project.id" :value="1">
                                <input type="button" value="+" @click="increase(project)">
                              </div>
                              <p :class="project.should_exclude != '1' ? 'btn-sec rml-10' : 'btn-sec'" style="display: inline-block;">
                                <button class="red-btn" @click="addToCart(project, project.selectedImpact)" :disabled="(user.role_id === 12)?true:false">
                                  Add to cart
                                </button>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="custRecurringOverlay" :id="'recurring' + project.id" style="display:none;">
                          <button class="close" @click="openCard('close', project.id)"><img :src="'/static/front/images/close-black-icon.svg'" alt="alt"></button>
                          <div class="custAddImpactLevelSec">
                            <div class="impactLevelTitle">
                              <div class="inner">
                                How would you like to proceed?
                              </div>
                            </div>
                            <div class="proceedOptions">
                              <a href="#" class="white-btn" @click="loadProjectModal(project, 'monthly')">Create Monthly Recurring Impacts</a>
                              <a href="#" class="white-btn" @click="loadProjectModal(project, 'manual')">Create Activity-based Impacts</a>
                            </div>
                          </div>
                        </div>
                        <div class="custProjectCardFooter" v-if="user">
                          <div class="tab" :id="'recurringBtn' + project.id" @click="openCard('recurring', project.id)" v-if="project.should_exclude != '1'">
                            <img :src="'/static/front/images/plus.svg'" alt="alt" style="width:17px">
                            Recurring Impacts
                          </div>
                          <div class="tab" :id="'addBtn' + project.id" @click="openCard('cart', project.id)">
                            <img :src="'/static/front/images/shopping_cart_icon_black.svg'" alt="alt" style="width:17px">
                            Add to Cart
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                  <i class="fas fa-chevron-left"></i>
                </a>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                  <i class="fas fa-chevron-right"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top:15px;">
            <div class="col-md-12 d-flex justify-content-center">
            </div>
          </div>
        </div>
        <div class="container" v-else>
          <div class="row">
            <div class="col-md-12 text-center" >
                <a href="https://b1g1.com" target="_blank" style="width:inherit;">
                  <img :src="'/static/front/images/22Website_-_Worthy_Cause_Banner.png'" alt="alt" style="width:inherit; margin-bottom: 30px;">
                </a>
            </div>
          </div>
        </div>
      </section>

      <modal class="diff-wcu-popup" name="wcuContactInfoModal" transition="pop-out" :width="400" :adaptive="true" :maxWidth="400" height="auto" :scrollable="true">
        <div class="modal-content">
          <div class="modal-head">
            <h5 class="modal-title team-member-ti" id="exampleModalLongTitle">{{partner.org_name}}</h5>
            <button type="button" class="close" @click="$modal.hide('wcuContactInfoModal')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pop-form">
            <div class="cuisine-sec">
              <aside v-if="partner.User">
                <h5>Contact info</h5>
                <ul>
                  <li><i class="fas fa-user"></i> {{ partner.User.first_name + ' ' + partner.User.last_name }}</li>
                  <li><i class="fas fa-envelope"></i>
                    <a @click="displayGetInTouchModal" >Send an e-mail</a>
                  </li>
                </ul>
              </aside>
              <aside class="m-0" v-if="partner.org_opportunities && partner.org_opportunities.length > 0">
                <h5>Contact {{ partner.org_name }} for:</h5>
                <ul>
                  <li v-for="opp in partner.org_opportunities" v-bind:key="opp">
                    <a href="javascript:void(0)" v-if="opp === 'Volunteering / Pro-Bono'">{{opp}}</a>
                    <span v-else>{{opp}}</span>
                  </li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </modal>
      <modal class="diff-wcu-popup" name="wcuGetInTouchModal" transition="pop-out" :width="600" :adaptive="true" :maxWidth="600" height="auto" :scrollable="true">
        <div class="modal-content">
          <div class="modal-head">
            <button type="button" class="close" @click="$modal.hide('wcuGetInTouchModal')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pop-form">
            <section class="team-member">
              <img src="/static/front/images/get-in-touch.png" alt="get-in-touch.png"><br>
              <div class="form-sec">
                <label>Your Name <em>*</em></label>
                <input type="text" :class="(getError('sender_user_name') ? ' error' : '')" v-model="form.sender_user_name" id="sender_user_name" name="sender_user_name" v-validate="'required'" maxlength="60"/>
              </div>
              <div class="form-sec">
                <label>Your B1G1 email address <em>*</em></label>
                <input type="text" :class="(getError('sender_user_email') ? ' error' : '')" v-model="form.sender_user_email" id="sender_user_email" name="sender_user_email" v-validate="'required|email'"/>
              </div>
              <div class="form-sec">
                <label>Subject <em>*</em></label>
                <input type="text" :class="(getError('email_subject') ? ' error' : '')" v-model="form.email_subject" class="form-control" id="email_subject" name="email_subject" v-validate="'required'"/>
              </div>
              <div class="form-sec m-0">
                <label>Your message <em>*</em></label>
                <textarea class="form-control" :class="(getError('email_message') ? ' error' : '')" v-validate="'required'" v-model="form.email_message" cols="10" rows="5" id="email_message" name="email_message"></textarea>
              </div>
              <div class="text-center">
                <button class="b-btn red-btn" @click="sendEmail()">send email</button>
                <button class="b-btn white-btn" @click="$modal.hide('wcuGetInTouchModal')">cancel</button>
              </div>
            </section>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import store from '../../../store'
import appAPI from '../../../api/app'
import userAPI from '../../../api/user'
import projectAPI from '../../../api/project'
import VuejsDialog from 'vuejs-dialog'
import Notify from 'vue2-notify'
import Moment from 'vue-moment'
import dragscroll from 'vue-dragscroll'
import vmodal from 'vue-js-modal'
import VeeValidate from 'vee-validate'
import config from '../../../config/app'
import NotificationMixin from '../../../helper/mixin/Notification'
import Paginate from 'vuejs-paginate'
import Vue2Filters from 'vue2-filters'
Vue.component('paginate', Paginate)
Vue.use(VeeValidate)
Vue.use(VuejsDialog)
Vue.use(Notify)
Vue.use(Moment)
Vue.use(vmodal)
Vue.use(Vue2Filters)

export default {
  computed: {
    countPages () {
      return Math.ceil(this.partner.User ? this.partner.User.wcu_projects.length / this.countPerPage : 0)
    },
    start () {
      return (this.page - 1) * this.countPerPage
    }
  },
  mixins: [NotificationMixin],
  methods: {
    increase (project) {
      const qty = document.getElementById('qty' + project.id)
      if (qty.value < 1000000 && qty.value > 0) {
        qty.value++
      } else {
        qty.value = 1
      }
      // this.updateQuantity(project)
    },
    decrease (project) {
      const qty = document.getElementById('qty' + project.id)
      if (qty.value !== '1' && qty.value > 0) {
        qty.value--
      } else {
        qty.value = 1
      }
    },
    loadProjectModal (project, type) {
      if (this.introjsData.display_project_modal === '0' && project.is_bundle !== '1' && project.country.name !== 'Global') {
        this.selectedProject = project
        this.recurringType = type
        this.$modal.show('non-global-warning-modal')
      } else {
        this.recurringType = type
        this.createGivingStory(project)
      }
    },
    openCard (card, id) {
      if (card === 'recurring') {
        const recurring = document.getElementById('recurring' + id)
        recurring.style.display = 'flex'
        const cart = document.getElementById('cart' + id)
        cart.style.display = 'none'
        const addBtn = document.getElementById('addBtn' + id)
        addBtn.classList.remove('active')
        const recurringBtn = document.getElementById('recurringBtn' + id)
        recurringBtn.classList.add('active')
      } else if (card === 'close') {
        const recurring = document.getElementById('recurring' + id)
        recurring.style.display = 'none'
        const cart = document.getElementById('cart' + id)
        cart.style.display = 'none'
        const addBtn = document.getElementById('addBtn' + id)
        addBtn.classList.remove('active')
        const recurringBtn = document.getElementById('recurringBtn' + id)
        recurringBtn.classList.remove('active')
      } else {
        const recurring = document.getElementById('recurring' + id)
        recurring.style.display = 'none'
        const cart = document.getElementById('cart' + id)
        cart.style.display = 'flex'
        const addBtn = document.getElementById('addBtn' + id)
        addBtn.classList.add('active')
        const recurringBtn = document.getElementById('recurringBtn' + id)
        recurringBtn.classList.remove('active')
      }
    },
    displayGetInTouchModal () {
      this.$modal.hide('wcuContactInfoModal')
      this.$modal.show('wcuGetInTouchModal')
    },
    scrollDown () {
      document.getElementById('scroll-here').scrollIntoView({
        behavior: 'smooth'
      })
    },
    setPage (page) {
      this.page = page
      if (this.$refs.paginateBottom) {
        this.$refs.paginateBottom.selected = page
      }
    },
    login () {
      window.location.href = config.host + '/login'
    },
    toggleGoal (goal) {
      this.sdgShow = this.sdgShow === goal.id ? null : goal.id
    },
    spacify (num) {
      // let str = num.toString().split('').reverse().join('')
      // str = str.replace(/(.{3})/g, '$1 ')
      // return str.split('').reverse().join('')
      return parseInt(num).toLocaleString('en')
    },
    loadCountries () {
      return appAPI.getCountries().then((response) => {
        this.countries = response
      })
    },
    loadfavProjects () {
      if (this.user !== null) {
        return projectAPI.getFavProjects(this.user.id, undefined, {
          status: 'live',
          project_approved: 1,
          is_company: store.getters.isCompanyAccount ? 1 : 0
        }).then((response) => {
          response.forEach((project) => {
            this.favProjects.push(project.id)
          })
        })
      } else {
        return true
      }
    },
    loadUser () {
      return userAPI.getPartner({id: this.$route.params.id}, ['Countries', 'User', 'User.WcuProjects', 'User.WcuProjects.Impacts', 'User.WcuProjects.ImageSquare', 'User.WcuProjects.ImageRectangle', 'User.WcuProjects.Country', 'User.WcuProjects.Categories', 'User.WcuProjects.Goals', 'OpeCountry', 'RegCountry']).then((response) => {
        if (response) {
          this.partner = response
          console.log('===============================')
          console.log(this.partner)
          let topCategoriesFound = {}
          var userProject = response.User ? response.User.wcu_projects : ''
          if (userProject) {
            userProject.forEach((project) => {
              let minCost = null
              if (project.impacts.length > 0) {
                project.impacts.forEach((impact) => {
                  if (impact.impact_level_cost < minCost || minCost === null) {
                    minCost = impact.impact_level_cost
                    project.current_impact = impact
                  }
                })
              }
              if (minCost !== null) {
                project.min_cost = minCost
                this.allProjects.push(project)
              }

              let categoryName = (project.categories[0]) ? project.categories[0].name : ''
              topCategoriesFound[categoryName] = typeof topCategoriesFound[categoryName] === 'undefined' ? 1 : (topCategoriesFound[categoryName] + 1)
            })
          }
          this.topCategories = Object.keys(topCategoriesFound).sort(function (a, b) {
            return topCategoriesFound[b] - topCategoriesFound[a]
          })
          if (response.User && response.User.wcu_projects) {
            response.User.wcu_projects = this.allProjects
            this.partner.User.wcu_projects = response.User.wcu_projects.filter(i => i.status === 'live')
            this.partner.User.wcu_projects.forEach((project) => {
              // let minCost = null
              project.impacts = projectAPI.commonImpactDataFilter(project.impacts)
              project.selectedImpact = (project.impacts && project.impacts.length) ? project.impacts[0] : null
            })
          }
          this.partner.org_name = response.org_name ? response.org_name.replace(/\\/g, '') : ''
        }

        document.title = this.partner.org_name
        if (this.partner.ope_country) {
          this.partner.countries = this.partner.ope_country
        }
        if (response && response.website) {
          if (response.website.indexOf('https://') >= 0) {
            this.partner.website = response.website
          } else {
            let website = response.website
            let websiteurl = website.replace('http://', '')
            this.partner.website = 'http://' + websiteurl
          }
        }
        // this.countPages = Math.ceil(this.partner.user.wcu_projects.length)
        this.setPage(1)
        if (this.partner.User && this.partner.User.wcu_projects.length > 1) {
          // this.scrollerWidth = this.partner.user.wcu_projects.length * 330 + 90
          this.scrollerWidth = (this.partner.User.wcu_projects.length + 1) * 300
        } else {
          this.scrollerWidth = 840
        }
        // If opportunities are exist
        if (this.user_current_role_id !== 1 && this.user_current_role_id !== 0) {
          if (this.partner.org_opportunities && this.partner.org_opportunities.length > 0) {
            this.getOpportunity = (this.partner.org_opportunities.length - 1)
            this.is_opportunity = 1
          }
        }
        // If organization story images OR videos is not blank
        if (this.partner.org_story) {
          this.partner.org_story = JSON.parse(this.partner.org_story)
          if (this.partner.org_story !== null) {
            if (this.partner.org_story.story_media.length > 0) {
              if (this.partner.org_story.story_media[0].type !== '') {
                // Get story images and video length
                this.is_org_story = true
              }
            }
          }
        }
      })
    },
    getPartnerImpacts () {
      userAPI.getPartnerTotalImpacts({partnerId: this.$route.params.id}).then((response) => {
        this.companyTotalImpact = response.partner_total_imapcts
      })
    },
    // addToCart (project, impact) {
    //   // If impact is exist
    //   if (impact) {
    //     let companyId = this.user.account === 'company' && this.user.user_business ? this.user.user_business.company_id : null
    //     store.dispatch('addToGivingCart', {projectId: project.id, impactId: impact.id, type: 'project', storyId: null, count: 1, user_id: this.user.id, company_id: companyId, amt_total_usd: impact.impact_level_cost, beneficiaries: impact.impact_unit, single_contribution_total: impact.impact_level_cost, quantity: 1})
    //   }
    // },
    addToCart (project, impact) {
      this.display.loading = true
      if (this.user !== null) {
        const qty = document.getElementById('qty' + project.id)
        store.dispatch('addToGivingCart', {
          projectId: project.id,
          impactId: impact.id,
          type: 'project',
          user_id: this.user.id,
          company_id: this.user.account === 'company' && this.user.user_business && this.user.user_business.company_id ? this.user.user_business.company_id : null,
          impact_level_id: impact.id,
          amt_total_usd: impact.impact_level_cost,
          count: qty.value,
          story_group_id: null,
          beneficiaries: impact.impact_unit,
          single_contribution_total: impact.impact_level_cost
        }).then(() => {
          this.display.loading = false
          if (this.favProjects.length > 0) {
            document.getElementById('cartnumber').classList.add('cart-animate')
            setTimeout(function () {
              document.getElementById('cartnumber').classList.remove('cart-animate')
            }, 400)
          }
          this.bToast('success', 'Item added to cart.')
        })
      } else {
        this.display.loading = false
        return true
      }
    },
    fav (project, type) {
      this.display.loading = true
      let projectId = project.id
      projectAPI.favProject(this.user.id, projectId, store.getters.isCompanyAccount, type).then((response) => {
        this.display.loading = false
        let index = this.favProjects.indexOf(projectId)
        if (index !== -1) {
          this.favProjects.splice(index, 1)
          document.getElementById(projectId).classList.remove('red-heart')
          this.bToast('success', 'Project removed from Favorites.')
          project.is_favorite = 0
        } else {
          project.is_favorite = 1
          this.favProjects.push(projectId)
          document.getElementById(projectId).classList.add('red-heart')
          this.bToast('success', 'Project added to Favorites.')
        }
      })
    },
    isFav (projectId) {
      return this.favProjects.indexOf(projectId) === -1
    },
    getCountryName (id) {
      return this.countries.filter(i => i.id === id).length > 0 ? this.countries.filter(i => i.id === id)[0].name : ''
    },
    getLowestImpact (impacts) {
      if (impacts.length > 0) {
        return impacts.reduce((min, i) => i.impact_level_cost < min ? i.impact_level_cost : min, impacts[0].impact_level_cost)
      }
    },
    sendEmail () {
      let data = this.form
      data.partner_user_id = this.partner.User.id
      data.partner_user_email = this.partner.User.email
      data.partner_user_firstname = this.partner.User.first_name
      data.sender_user_firstname = this.user.first_name
      this.$validator.validateAll(data).then((res) => {
        if (!res) {
          this.bToast('error', 'Please fill red fields')
          // Vue.$notify('Please fill red fields', 'error')
          return false
        } else {
          this.sending = true
          userAPI.sendEmailToPartner(data).then((response) => {
            this.sending = false
            if (response.status === true) {
              this.$modal.hide('wcuGetInTouchModal')
              this.form.email_subject = null
              this.form.email_message = null
              Vue.$notify('Email successfully sent!', 'success')
            }
          }, (error) => {
            if (error.status === 500) {
              Vue.$notify(error.body.error, 'error')
            }
          })
        }
      })
    },
    getError (name) {
      return this.errors.items.filter(i => i.field === name).length > 0
    },
    selectDetailedProject (project) {
      this.detailedProject = project
      if (project.impacts.length > 0) {
        this.selectedImpactLevel = project.impacts[0]
      }
      this.$modal.show('project-details-modal')
    },
    closeDetailedProject () {
      this.detailedProject = null
    },
    onImageLoadFailure (event, id) {
      if (id === 'banner_image') {
        document.getElementById(id).src = config.host + '/static/front/images/wcu-default-banner-new.png'
      } else {
        document.getElementById(id).src = config.host + this.defaultImg
      }
    },
    getProjectImage (img) {
      if (!img) {
        return this.host + this.defaultProjectImg
      } else {
        return img
      }
    },
    redirectAnotherProject (project) {
      let url = config.host + (parseInt(project.is_bundle) === 0 ? '/projectdetail/' : '/bundledetail/') + project.id
      window.open(url, '_blank')
    }
  },
  data () {
    return {
      defaultImg: '/static/front/images/no-image.jpg',
      defaultImage: '/static/logos/b1g1-light-widget.png',
      getOpportunity: 0,
      countPerPage: 4,
      sdgShow: null,
      page: 1,
      user: store.getters.currentUser,
      partner: [],
      allProjects: [],
      selectedImpactLevel: 0,
      detailedProject: null,
      favProjects: [],
      favCategories: [],
      topCategories: [],
      companyTotalImpact: 0,
      display: {
        loading: false,
        loaded: false
      },
      scrollerWidth: 0,
      sending: false,
      form: {
        sender_user_name: store.getters.currentUser ? (store.getters.currentUser.first_name + ' ' + store.getters.currentUser.last_name) : null,
        sender_user_email: store.getters.currentUser ? store.getters.currentUser.email : null,
        email_subject: null,
        email_message: null
      },
      user_current_role_id: store.getters.currentUser ? store.getters.currentUser.role_id : 0,
      is_opportunity: 0,
      is_valid_opportunity: 1,
      is_org_story: false
    }
  },
  created () {
    this.display.loading = true
    let countriesPromise = this.loadCountries()
    let favProjectsPromise = this.loadfavProjects()
    let userPromise = this.loadUser()
    let getImpactPromise = this.getPartnerImpacts()
    if (this.user === null) {
      localStorage.setItem('b1g1_reload_url', window.location)
    } else {
      localStorage.setItem('b1g1_reload_url', '')
    }
    Promise.all([countriesPromise, favProjectsPromise, userPromise, getImpactPromise]).then(() => {
      this.display.loading = false
      this.display.loaded = true
    })
  },
  directives: {
    dragscroll
  },
  components: {
    Paginate
  }
}
</script>

<style scoped>
.header-img img{
  object-fit: cover;
}
@media (max-width:767px) {
  .team-member {
    padding: 10px 10px;
  }
}
.custRecurringOverlay{
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/business/profile/Partner.vue